import { render, staticRenderFns } from "./serviceOrder.vue?vue&type=template&id=10a9abde&scoped=true&"
import script from "./serviceOrder.vue?vue&type=script&lang=js&"
export * from "./serviceOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a9abde",
  null
  
)

export default component.exports